<body>
<div style="background:#F3FFFE">
  <div id="titlebox" style="    background: white;
  border: #cecbcb;
  border-width: 2px;
  border-style: solid;
  border-top: 0px;">
    <h3 style="font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    align-items: center;
    text-align: center;
    color: #424242;
    padding: 8px;">Timecard</h3>
    <h5 style="font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    color: #8a8a8a;"> <!--{{data?.day.day.substring(0,10)  }} --> {{data?.day.day.substring(0,10)}}</h5>


    <div class="titleBoxFlex">

      <div style="width:50%;">
        <h4 style="    font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        /* line-height: 16px; */
        align-items: center;
        text-align: left;
        color: #477333;
        padding-left: 20px;"> Start: {{ getTimeZoneDate(data?.day.daystart, false) }}</h4>


        <h4 style="    font-family: 'Roboto';
        font-style: normal;
        padding-left: 20px;
        font-weight: 500;
        font-size: 16px;
        color: #424242;">  Pause Time: {{ intervalToString(data.day.pausetime) }}</h4>

        <h4 style="font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        text-align: left;
        color: #910000;
        padding-left: 20px;"> End: {{ data.day.dayend ? getTimeZoneDate(data?.day.dayend, true): '(Day still in progress)' }} </h4>

      </div>

      <div style="width:50%;">

        <h4 style="font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #424242;"> Travel  {{ calculateTravelTime(data.day) }} </h4>

        <h4 style="    font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #424242;"> Onsite {{ intervalToString(data.day.jobtime) }}</h4>


        <h4 style="    font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #424242;" 
        >  Paid Time: {{ calculatePaidTime(data.day) }}</h4>
      </div>
    </div>

    <div>
      <h4 style="font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      color: #424242;
      padding-left: 20px;"> Total Time: {{ calculateTotalTime(data.day) }} </h4>
    </div>

    <div style="display: flex; justify-content: flex-end; align-items: center; padding: 5px 20px 10px;">
      <i class="fa fa-sticky-note-o"
         style="color: #477333; cursor: pointer; font-size: 18px; margin-right: 6px;"
         (click)="openNoteDialog(null)"
         title="Add general timecard note"></i>
      <span style="color: #477333; cursor: pointer; font-size: 14px; font-weight: 500;"
            (click)="openNoteDialog(null)">Add Note</span>
      <span *ngIf="generalNoteCount > 0" style="background: #477333; color: white; border-radius: 50%;
            width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;
            font-size: 11px; margin-left: 5px;">{{ generalNoteCount }}</span>
    </div>

  </div>
    <div style="border-width: 1px 0px;
    border-style: solid;
    border-color: #E9E6E6;
    height: 30vh;
    overflow-y: scroll;
    background-color: white;">

      <div id="repeating" *ngFor = 'let job of data.jobs' style="background: rgb(255 255 255);
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      margin-bottom: 8px;
      padding: 8px;
      display:flex;
      flex-direction: row;">
      <div>
        <h4 style="font-family: 'Roboto';
          font-weight: bold;
          font-size: 24px;
          align-items: center;
          color: #424242;
          letter-spacing: 0.4px;
          padding: 20px;">
          {{job.subdivision_name}}- {{job.lot}} 
          <div style="font-weight:200;font-size:0.75em;">{{job.street_address}}</div>
          <span style="font-weight: 500;">{{timeFunction(job.totaltime)}}</span>
        </h4>
      </div>
        <div style="align-content: center;">
            <div>
              <h4 style="    font-family: 'Roboto';
              font-weight: 500;
              font-size: 20px;
              color: #8a8a8a;
              padding-left: 20px;">
                {{job.customer_jobtype}}  
              </h4>
            </div>


            <div style="display:flex; flex-direction:column;">
                <div style="display:flex; align-items:center;">
                    <h4 style="    font-family: 'Roboto';
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 16px;
                    color: #6e6d6d;
                    padding-left: 20px;"> <!--{{data?.day.day.substring(0,10)  }} --> Clock-in: {{ getTimeZoneDate(job.starttime, false)  }}</h4>
                </div>

                <div style="display:flex; align-items:center;">
                    <h4 style="    font-family: 'Roboto';
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 16px;
                    color: #6e6d6d;
                    padding-left: 20px;"> <!--{{data?.day.day.substring(0,10)  }} --> Clock-out: {{ getTimeZoneDate(job.endtime, false) }}</h4>
                </div>

                <div style="display:flex; align-items:center; margin-top: 10px;">
                    <i *ngIf="canEditTimes == true" class="fa fa-edit"
                       style="color: #477333; cursor: pointer; margin-left: 20px; font-size: 18px;"
                       (click)="openEditTimeModal(job)"
                       title="Edit clock-in and clock-out times"></i>
                    <i class="fa fa-sticky-note-o"
                       style="color: #477333; cursor: pointer; margin-left: 16px; font-size: 18px;"
                       (click)="openNoteDialog(job)"
                       title="Add note for this job"></i>
                    <span *ngIf="getJobNoteCount(job.job_id) > 0"
                          style="background: #477333; color: white; border-radius: 50%;
                          width: 18px; height: 18px; display: inline-flex; align-items: center;
                          justify-content: center; font-size: 11px; margin-left: 4px;">
                      {{ getJobNoteCount(job.job_id) }}
                    </span>
                </div>

            </div>
        </div>


      </div>


    </div>
  </div>

  <div>
    <button class="timeCloseClass" [mat-dialog-close]="{}"><i class="fa fa-close fa-2x" style="color:black; margin-left: 11px;"></i></button>
  </div>


</body>
